module.exports = "./images/16_pariticosmetic.jpg";